export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["معلومات التسجيل"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حفظ البيانات"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم التحقق"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["هذا الحقل عام ومرئي للمستخدمين الآخرين"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["هذا الحقل مخفي عن المستخدمين الآخرين"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["التحقق من الهوية"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم التحقق"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["قيد التنفيذ"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لم يتم التحقق"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["بدء التحقق"])}
}